import { ServerEndpoint } from '../Redux/endpoints.ts';
import { post } from './ApiService';

const ContactService = {

  // --- Private Helper to ensure consistency ---
  async _dispatch(endpoint, data, source, subject, attachments = []) {
    const payload = {
      answers: data, // The actual form fields
      metadata: {
        source: source,
        subject: subject || `New Submission from ${source}`
      }
    };
    return await post(endpoint, payload, true, 'שולח נתונים...', attachments);
  },

  /**
   * Generic Form (PWA / Multi-step)
   */
  async submitForm(payload, attachments = []) {
    return await post(ServerEndpoint.SUBMIT_FORM, payload, true, 'שולח טופס...', attachments);
  },

  /**
   * Standard Contact Form
   */
  async sendContact(data) {
    return this._dispatch(
      ServerEndpoint.CONTACT,
      data,
      "Contact Form",
      `פנייה חדשה: ${data.fullName}`
    );
  },

  /**
   * Project Quiz / Assessment
   */
  async sendQuiz(data) {
    return this._dispatch(
      ServerEndpoint.QUIZ,
      data,
      "Quiz/Assessment",
      `שאלון פרויקט: ${data.businessName || data.fullName}`
    );
  },

  /**
   * Product / Support Inquiry
   */
  async sendSupport(data) {
    return this._dispatch(
      ServerEndpoint.INQUIRY,
      data,
      "Support/Inquiry",
      `בירור שירות: ${data.subject}`
    );
  },

  /**
   * Service Agreement
   */
  async submitAgreement(agreementData) {
    return this._dispatch(
      ServerEndpoint.TERMS_HOSTING,
      agreementData,
      "Hosting Terms",
      "חתימה על הסכם שירות"
    );
  }
};

export default ContactService;